import xw from 'xwind';
import styled from '@emotion/styled';

export const Tools = styled.div(({ toolId }: { toolId: number }) => [
  xw`
      w-full flex mt-14 flex-col 
      md[flex-row  items-center] 
    `,
  toolId % 2 !== 1 && xw`md:flex-row-reverse `,
]);

export const ImagesWrapper = styled.div(
  xw`
      w-full mb-8 md[w-1/2 mb-0] overflow-hidden bg-gray-200 max-w-md
    `,
);

export const Text = styled.div(({ toolId }: { toolId: number }) => [
  xw`
      w-full md:w-1/2 
    `,
  toolId % 2 !== 1
    ? xw`sm:pr-0 md:pr-16 lg:pr-32`
    : xw`sm:pl-0 md:pl-16 lg:pl-32`,
]);

export const Title = styled.h3(
  xw`
      mb-5
      text-gray-900 tracking-wider
      md[text-xl] 
      lg[text-3xl mb-10]  
    `,
);

export const Description = styled.p(
  xw`
      mb-5
      text-sm text-gray-400 
      md[mb-7 text-base] lg[mb-14 text-xl]
    `,
);

export const Button = styled.button(
  xw`
      flex flex-row items-center py-2.5 px-7
      text-white text-base bg-active 
      border border-primary rounded-full
      outline-none focus:outline-none
    `,
);
